import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { useContextHook } from "../../Context/ContextOPen";
import { Container } from "../../Tools/Grid-system";

import logo from "../../images/logo.png";
import { dataProjects } from "./dataProjects";
import { FaExternalLinkAlt } from "react-icons/fa";
const Projects = () => {
  const [open, setOpen] = useState();
  const { swiperIndex, content, direction } = useContextHook();

  return (
    <div className="">
      <Container>
        <h1
          style={{ direction: direction }}
          className={`text-5xl max-lg:text-4xl font-bold mb-5 logo first-letter:text-Main transition-all ${
            swiperIndex === 3 ? "hero" : ""
          }`}
        >
          {content.Projects}
        </h1>
      </Container>
      <div className="">
        <Swiper
          className="min-h-[60vh] "
          spaceBetween={20}
          pagination={{ clickable: true }}
          style={{ direction: "rtl" }}
          breakpoints={{
            1150: {
              slidesPerView: 4.2,
            },
            992: {
              slidesPerView: 3.1,
            },
            768: {
              slidesPerView: 3,
            },
            420: {
              slidesPerView: 2,
            },
            0: {
              slidesPerView: 1.1,
            },
          }}
        >
          <SwiperSlide className="py-2 min-h-[60vh]  !flex justify-center items-center  ">
            <img src={logo} alt="" className=" " />
          </SwiperSlide>
          {dataProjects.map((e, i) => (
            <SwiperSlide key={i} className="py-2">
              <CardFeature open={open} setOpen={setOpen} index={i} data={e} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <PopUpProject open={open} setOpen={setOpen} />
    </div>
  );
};

export default Projects;

const CardFeature = ({ setOpen, data }) => {
  const { direction, content } = useContextHook();
  return (
    <a href={data.link} target="_blank" className="group">
      <div
        style={{ direction: direction }}
        onClick={() => setOpen(data?.id)}
        className="!h-full w-full  brabusShadow overflow-hidden rounded-xl "
      >
        <div
          style={{ direction: "rtl" }}
          className="relative h-[230px] p-0 m-0 "
        >
          <img src={data?.main} alt="" className="w-full h-full object-cover" />
        </div>
        <div className="py-2">
          <div className="flex items-center gap-3 px-5">
            <FaExternalLinkAlt
              size={18}
              className=" cursor-pointer -translate-x-10  group-hover:translate-x-0 transition-all"
            />

            <h1 className="my-1 font-bold text-xl text-Main transition-all">
              {content["projects_name_" + data?.id]}
            </h1>
          </div>
          <p className="text-sm leading-6 max-xxl:leading-5 max-md:leading-6 pb-3 px-2">
            {content["projects_description_" + data?.id]?.substring(0, 300) +
              "..."}
          </p>
        </div>
      </div>
    </a>
  );
};

const PopUpProject = ({ open, setOpen }) => {
  const dataProject = dataProjects.find((e) => e.id, open);
  const { content } = useContextHook();
  return (
    <>
      {/* {open ? (
        <>
          <div
            onClick={() => setOpen(0)}
            className="bg-Main/20 fixed top-0 left-0 w-full h-full z-40"
          />
          <div className="bg-Secondary w-[90%]  fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-3xl z-50">
            <Row className="h-full px-2">
              <Col md={5}>
                <div className="flex justify-center items-center !h-full ">
                  <div className="!h-[360px] w-full p-3">
                    <Swiper
                      modules={[Pagination]}
                      loop={true}
                      className="!p-0 !m-0 bg-white/20 rounded-3xl"
                      spaceBetween={5}
                      pagination={{ clickable: true }}
                    >
                      {dataProject?.images?.map((e, i) => (
                        <SwiperSlide key={i} className=" ">
                          <img
                            src={e}
                            alt=""
                            className="w-full h-full object-contain rounded-3xl"
                          />
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                </div>
              </Col>
              <Col md={7} className="space-y-5">
                <div className="text-2xl">
                  <i className="text-Main">title :</i>
                  <div className="pl-2">
                    {content["projects_name_" + dataProject?.id]}
                  </div>
                </div>
                <div className="text-xl">
                  <i className="text-Main">description :</i>
                  <div className="pl-2">
                    {content["projects_description_" + dataProject?.id]}
                  </div>
                </div>
                <a className="block" href={dataProject.link}>
                  <div className="text- cursor-pointer">
                    <i className="text-Main cursor-pointer">link : </i>
                    {dataProject.link}
                  </div>
                </a>
              </Col>
            </Row>
          </div>
        </>
      ) : (
        ""
      )} */}
    </>
  );
};
